module.exports = __webpack_public_path__ + "img/loghi-cantine-divinea-desktop.6443f937.jpg";